var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("v-autocomplete", {
        staticClass: "custom-v-autocomplete",
        style: _vm.customStyle,
        attrs: {
          label: _vm.$t(_vm.placeholder),
          items: _vm.items,
          "item-value": "id",
          "item-text": "desc",
          height: _vm.inputHeight,
          "return-object": "",
          disabled: _vm.disabled,
          multiple: "",
          dense: "",
          flat: "",
          solo: "",
          "search-input": _vm.searchInput,
        },
        on: {
          change: (val) => {
            _vm.handleChange(val)
            _vm.clearSearchInput()
          },
          blur: _vm.handleBlur,
          focus: _vm.handleFocus,
          "update:search-input": _vm.onUpdateSearchInput,
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function ({ index }) {
              return [
                !_vm.isInputFocused &&
                !_vm.labelDisplaySelection &&
                index === 0 &&
                !_vm.searchInput
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "pt-1 pb-1 text-body-1 text--text text--lighten-1",
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.labelDisplay) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isInputFocused &&
                _vm.labelDisplaySelection &&
                index === 0 &&
                !_vm.searchInput
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "pt-1 pb-1 text-body-1-medium text--text text--base",
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(_vm.labelDisplay) + "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
          {
            key: "item",
            fn: function ({ item }) {
              return [
                _c(
                  "div",
                  {
                    class: [
                      "text--text",
                      "text--base",
                      { "selected-item": _vm.isItemSelected(item) },
                      { "text-body-1-bold": _vm.isItemSelected(item) },
                      { "text-body-1": !_vm.isItemSelected(item) },
                    ],
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t(item.desc)) + "\n      "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "no-data",
            fn: function () {
              return [
                _c("div", { staticClass: "no-data-message-outer" }, [
                  _vm.searchInput &&
                  _vm.searchInput.trim().length > 0 &&
                  _vm.existsTech(_vm.searchInput)
                    ? _c("div", [_vm._v("Ya está seleccionada")])
                    : _vm.searchInput &&
                      _vm.searchInput.trim().length > 0 &&
                      !_vm.existsTech(_vm.searchInput)
                    ? _c(
                        "div",
                        { staticClass: "no-data-message-inner-fix mb-2" },
                        [
                          _c("span", {
                            staticClass:
                              "mb-2 no-data-message-text-fix text-body-2 text--text text--lighten-1",
                            attrs: { color: "info" },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("stemdoerDetail.experienceModal.message")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit(
                                    "create-tech",
                                    _vm.searchInput
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "stemdoerDetail.experienceModal.create"
                                    )
                                  ) +
                                  ": "
                              ),
                              _c("strong", [_vm._v(_vm._s(_vm.searchInput))]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c("div", [_vm._v("No hay resultados")]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selectedItems,
          callback: function ($$v) {
            _vm.selectedItems = $$v
          },
          expression: "selectedItems",
        },
      }),
      _vm._v(" "),
      _vm.mode === "chip"
        ? _c("SSelectorChips", {
            attrs: {
              selectedItems: _vm.selectedItems.map((i) => i.id),
              items: _vm.items,
              descriptionFor: (itemId) => {
                const item = _vm.items.find((i) => i.id === itemId)
                return item ? item.desc : itemId
              },
              removeItem: (itemId) => {
                _vm.selectedItems.splice(
                  _vm.selectedItems.findIndex((i) => i.id === itemId),
                  1
                )
                _vm.handleChange(_vm.selectedItems)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }